module.exports = __webpack_public_path__ + "static/index-bg.67393113.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/index-bg.png
// module id = 1023
// module chunks = 2